export default __webpack_public_path__ + "static/media/39.706a2684.png";